/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Socket as SocketType, io } from "socket.io-client";

import { NativeSocketEvents, SOCKET_UNAUTHORIZED, ServerSocketEvents } from "@vienna/common/src";

import { clientLogger } from "../../../lib/logging/datadog";
import { CurrentUser } from "../CurrentUser";
export class NotificationsSocket {
  private socket: SocketType;

  private user: CurrentUser;

  constructor(user: CurrentUser) {
    this.user = user;
    this.socket = io(`${process.env.API_URL!}/notifications`, {
      transports: ["websocket", "polling"], // don't use long polling, just use ws's
      autoConnect: false, // don't connect automatically
      reconnection: true, // reconnect automatically
      auth: (cb) => {
        if (typeof window !== "undefined") {
          const token = localStorage.getItem("token");
          cb({ token });
        }
      },
      path: "/notifications",
    });
    this.initializeListeners();
    this.socket.connect();
  }

  private initializeListeners(): void {
    this.socket.on(NativeSocketEvents.Connect, () => {
      clientLogger.log("Connected to notifications socket");
    });

    this.socket.on(NativeSocketEvents.ConnectError, (err) => {
      if (err.message === SOCKET_UNAUTHORIZED) {
        return;
      }
      setTimeout(() => this.socket.connect(), 500);
    });

    this.socket.on(
      ServerSocketEvents.Notification,
      (socketActivity: Notification, _metadata: Record<string, string | number>) => {
        clientLogger.log(JSON.stringify(socketActivity));
        this.user.handleNotification();
      }
    );
  }

  public stopListeningAndClose(): void {
    this.socket.removeAllListeners();
    this.socket.close();
  }
}
